import { render } from "./TheFaq.vue?vue&type=template&id=28d39841"
import script from "./TheFaq.vue?vue&type=script&lang=js"
export * from "./TheFaq.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__